// extracted by mini-css-extract-plugin
module.exports = {"services":"k7xzztSWMO9KFq5RaPKrNA==","servicesList":"pKPdWYTXEqq4LwzrdCo5fQ==","service":"PRONoYydY5SiqMbuvn5GqQ==","serviceImage":"we-tlhNWV+pIMYK7lhvJDw=="};